import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cert-manager-summary" }
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 3,
  class: "text-muted"
}

import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export interface SummaryItem {
  label: string;
  value?: string | number | null;
  /** Render the value as an internal link. */
  to?: RouteLocationRaw | null;
  /** Render the value as an external link. */
  href?: string | null;
  /** Drop the item entirely rather than showing a dash. */
  hideIfEmpty?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailSummary',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props;

const visible = computed(() => props.items.filter((item) => !item.hideIfEmpty || item.value));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visible.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.label,
        class: "item"
      }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(item.label), 1),
        _cache[0] || (_cache[0] = _createTextVNode()),
        (item.to && item.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: item.to
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.value), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (item.href && item.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: item.href,
                target: "_blank",
                rel: "noopener noreferrer nofollow"
              }, _toDisplayString(item.value), 9, _hoisted_3))
            : (item.value || item.value === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.value), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "—"))
      ]))
    }), 128))
  ]))
}
}

})